import Vue from 'vue'

import router from './router'
import Account from '../scripts/account'

router.afterEach(to => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
  if (window.ga) {
    window.ga('set', 'page', to.fullPath)
    window.ga('send', 'pageview')
  }
})

router.beforeEach(async (to, from, next) => {
  // 登陆状态判断
  if (Vue.prototype.$user || to.meta.static) {
    // 已登陆或静态页面跳过身份检测
    next()
  } else {
    try {
      // 调用后台身份接口
      let user = await Account.own()
      if (!Account.check(user)) {
        next('/login')
      } else {
        // 将user信息放在Vue原型上
        Vue.prototype.$user = user
        next()
      }
    } catch (e) {
      next('/login')
    }
  }

  // 更新页面标题
  window.document.title = to.meta.title || Vue.prototype.$appName
})
